function initLayout() {
  const switcherCtas = document.querySelectorAll('.layout_switcher_cta');
  const productGrid = document.querySelector('#product-grid');
  const defaultLayout = 'grid';
  
  const savedLayout = localStorage.getItem('layoutMode') || defaultLayout;
  productGrid.setAttribute('data-layout', savedLayout);
  
  switcherCtas.forEach(cta => {
    if (cta.getAttribute('data-layout-mode') === savedLayout) {
      cta.classList.add('active');
    } else {
      cta.classList.remove('active');
    }
  });

  switcherCtas.forEach(cta => {
    cta.addEventListener('click', function () {
      switcherCtas.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      const layoutMode = this.getAttribute('data-layout-mode');
      productGrid.setAttribute('data-layout', layoutMode);
      localStorage.setItem('layoutMode', layoutMode);
    });
  });
}

function initgrid() {
    document.querySelectorAll('.custo_collection_product_grid').forEach(function(mainGrid) {
      const productGrid = mainGrid.querySelector("#product-grid");
        if (!productGrid) return;

        const blocks = mainGrid.querySelectorAll("[data-position]");

        blocks.forEach((block) => {
            if (!productGrid) return;
            let position = parseInt(block.getAttribute("data-position"), 10);
            let targetItem = productGrid.querySelector(`.grid__item_${position}`);

            if (!targetItem) {
            const allItems = [...productGrid.querySelectorAll(".grid__item")];
            const lastItem = allItems[allItems.length - 1];
            const lastPosition = parseInt(lastItem?.className.match(/grid__item_(\d+)/)?.[1] || 1, 10);
            position = position % 2 === 0 ? lastPosition - (lastPosition % 2) : lastPosition - ((lastPosition + 1) % 2);
            targetItem = productGrid.querySelector(`.grid__item_${position}`);
            }

            if (targetItem) {
            productGrid.insertBefore(block, targetItem);
            } else {
            productGrid.appendChild(block);
            }
        });
    });
};

function initfilter() {
    document.querySelectorAll('.custo_collection_product_grid').forEach(function(mainEle) {
        const filterCta = mainEle.querySelector(".vertical_filter_cta.custom_cta");
        const facetsWrapper = mainEle.querySelector(".facets-wrapper");

        if (filterCta && facetsWrapper) {
            filterCta.addEventListener("click", function () {
                facetsWrapper.classList.toggle("hidden");
            });
        }
    });
};


document.addEventListener("DOMContentLoaded", () => {
  initLayout();
  initgrid();
  initfilter()
});

document.addEventListener("on:facet-filters:updated", () => {
  initLayout();
  initgrid();
  initfilter();
});













// document.addEventListener('DOMContentLoaded', function () {
//   const switcherCtas = document.querySelectorAll('.layout_switcher_cta');
//   const productGrid = document.querySelector('#product-grid');

//   switcherCtas.forEach(cta => {
//     cta.addEventListener('click', function () {
//       // Remove active class from all CTAs
//       switcherCtas.forEach(btn => btn.classList.remove('active'));
//       // Add active class to clicked CTA
//       this.classList.add('active');
//       // Update data-layout attribute on product-grid
//       const layoutMode = this.getAttribute('data-layout-mode');
//       productGrid.setAttribute('data-layout', layoutMode);
//     });
//   });
// });




// class LayoutSwitcher extends HTMLElement {
//     constructor() {
//         super(),
//         this.cookieName = "collection-layout",
//         this.initLayoutMode(),
//         this.buttons.forEach(button => {
//             button.addEventListener("click", this.onButtonClick.bind(this))
//         }
//         )
//     }
//     get buttons() {
//         return this.querySelectorAll(".layout_switcher_cta")
//     }
//     onButtonClick(evt) {
//         const target = evt.currentTarget ? evt.currentTarget : evt;
//         this.changeLayout(target, target.dataset.layoutMode)
//     }
//     initLayoutMode() {
//         if (FoxTheme.config.hasLocalStorage) {
//             const layoutMode = window.localStorage.getItem(this.cookieName);
//             if (layoutMode !== null) {
//                 const target = this.querySelector(`button[data-layout-mode="${layoutMode}"]`);
//                 target && this.changeLayout(target, layoutMode)
//             }
//         }
//     }
//     changeLayout(target, layoutMode) {
//         const productGrid = document.getElementById("product-grid");
//         if (!productGrid)
//             return;
//         productGrid.dataset.layout = layoutMode;
//         const {gridClass, listClass} = productGrid.dataset;
//         if ((gridClass || listClass) && gridClass !== listClass) {
//             const productCards = productGrid.querySelectorAll(".collection_prod_grid_item");
//             productCards && productCards.forEach(card => {
//                 layoutMode === "grid" ? (listClass && card.classList.remove(listClass),
//                 gridClass && card.classList.add(gridClass)) : (gridClass && card.classList.remove(gridClass),
//                 listClass && card.classList.add(listClass))
//             }
//             )
//         }
//         this.buttons.forEach(button => {
//             button.classList.remove("active")
//         }
//         ),
//         target.classList.add("active"),
//         FoxTheme.config.hasLocalStorage && window.localStorage.setItem(this.cookieName, layoutMode)
//     }
// }
// customElements.define("layout-switcher", LayoutSwitcher);

// class LayoutSwitcher extends HTMLElement {
//     constructor() {
//         super();
//         this.cookieName = "collection-layout";
//         this.initLayoutMode();

//         this.buttons.forEach(button => {
//             button.addEventListener("click", this.onButtonClick.bind(this));
//         });
//     }

//     get buttons() {
//         return this.querySelectorAll(".layout_switcher_cta");
//     }

//     onButtonClick(evt) {
//         const target = evt.currentTarget ? evt.currentTarget : evt;
//         this.changeLayout(target, target.dataset.layoutMode);
//     }

//     initLayoutMode() {
//         if (this.hasLocalStorage()) {
//             const layoutMode = window.localStorage.getItem(this.cookieName);
//             if (layoutMode !== null) {
//                 const target = this.querySelector(`.layout_switcher_cta[data-layout-mode="${layoutMode}"]`);
//                 target && this.changeLayout(target, layoutMode);
//             }
//         }
//     }

//     changeLayout(target, layoutMode) {
//         const productGrid = document.getElementById("product-grid");
//         if (!productGrid) return;

//         productGrid.dataset.layout = layoutMode;

//         const { gridClass, listClass } = productGrid.dataset;
//         if ((gridClass || listClass) && gridClass !== listClass) {
//             const productCards = productGrid.querySelectorAll(".collection_prod_grid_item");
//             productCards.forEach(card => {
//                 if (layoutMode === "grid") {
//                     listClass && card.classList.remove(listClass);
//                     gridClass && card.classList.add(gridClass);
//                 } else {
//                     gridClass && card.classList.remove(gridClass);
//                     listClass && card.classList.add(listClass);
//                 }
//             });
//         }

//         this.buttons.forEach(button => button.classList.remove("active"));
//         target.classList.add("active");

//         if (this.hasLocalStorage()) {
//             window.localStorage.setItem(this.cookieName, layoutMode);
//         }
//     }

//     // ✅ Safe check for localStorage
//     hasLocalStorage() {
//         try {
//             const test = "__test__";
//             window.localStorage.setItem(test, test);
//             window.localStorage.removeItem(test);
//             return true;
//         } catch (e) {
//             return false;
//         }
//     }
// }
// customElements.define("layout-switcher", LayoutSwitcher);



// document.addEventListener("DOMContentLoaded", () => {
//   const switchers = document.querySelectorAll('.layout_switcher');
//   const cookieName = 'Get_collection_layout';

//   // 1️⃣ Read saved layout from localStorage or default to 'grid'
//   const savedLayout = window.localStorage.getItem(cookieName) || 'grid';
//   console.log("savedLayout====>", savedLayout);

//   // 2️⃣ Apply saved layout to all grids immediately
//   document.querySelectorAll('.custo_collection_product_grid .collection_page_product_grid').forEach((grid) => {
//     if (!grid) return;
//     grid.dataset.layout = savedLayout;
//   });

//   // 3️⃣ Update active buttons in all switchers immediately
//   switchers.forEach((switcher) => {
//     const buttons = switcher.querySelectorAll('.layout_switcher_cta');
//     buttons.forEach((btn) => {
//       btn.classList.remove('active');
//       if (
//         (savedLayout === 'grid' && btn.classList.contains('layout_switcher_grid')) ||
//         (savedLayout === 'list' && btn.classList.contains('layout_switcher_list'))
//       ) {
//         btn.classList.add('active');
//       }
//     });

//     // 4️⃣ Add click listeners
//     buttons.forEach((button) => {
//       button.addEventListener('click', () => {
//         const mode = button.dataset.layoutMode || (button.classList.contains('layout_switcher_grid') ? 'grid' : 'list');

//         // Update all grids
//         document.querySelectorAll('.custo_collection_product_grid .collection_page_product_grid').forEach((grid) => {
//           if (!grid) return;
//           grid.dataset.layout = mode;
//         });

//         // Update buttons in this switcher
//         buttons.forEach((btn) => btn.classList.remove('active'));
//         button.classList.add('active');

//         // Save globally
//         window.localStorage.setItem(cookieName, mode);
//       });
//     });
//   });
// });

